import React from 'react';
import Slider from "react-slick";

import * as Icons from '../Icons';

let testimonialConig = {
  mobileFirst: true,
  slidesToShow: 2,
  dots: true,
  centerPadding: '10px',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
}

const Reviews = () => {
  return (<section className="section-testimonial sticker section-padding" id="reviews">
    <div className="dish-6">
      <img src={Icons.dish6} alt="" />
    </div>
    <div className="container">
      <div className="section-heading text-center">
        <h2 className="title">What Our Customers Say</h2>
      </div>
      <div className="testimonial slider">
        <Slider {...testimonialConig}>
          <div className="testimonial-item">
            <div className="copy">
              <p className="text">
                My penchant for food was limited to me and my family members. Thanks to EnjoyFresh, now I am becoming popular as a Chef. The traditional food I prepare is loved and ordered by many!            </p>
            </div>
            <div className="media">
              <img src={Icons.man} alt="" />
            </div>
            <div className="name">
              Jenny Doe
            </div>
            <div className="rate">
              <img src={Icons.star} className="img-fluid mx-auto d-block" alt="" />
            </div>
          </div>
          <div className="testimonial-item">
            <div className="copy">
              <p className="text">
                I am a traditional pickle maker. EnjoyFresh gave me a platform and made my spicy, and fresh pickles (devoid of preservatives) go immensely popular. I am thankful to the EnjoyFresh app for facilitating my small business.            </p>
            </div>
            <div className="media">
              <img src={Icons.manTwo} alt="" />
            </div>
            <div className="name">
              Sohil Pathan
            </div>
            <div className="rate">
              <img src={Icons.star} className="img-fluid mx-auto d-block" alt="" />
            </div>
          </div>
          <div className="testimonial-item">
            <div className="copy">
              <p className="text">
                The food I ordered on EnjoyFresh app was delivered to me in less than two hours. The food was so fresh that each morsel made me drool for the next one. I was missing my traditional meals earlier, but EnjoyFresh came as a perfect solution at the ideal time. The quality of food and the taste enraptured me. The aroma that spreads in my dining room entices my neighbours too.            </p>
            </div>
            <div className="media">
              <img src={Icons.lady} alt="" />
            </div>
            <div className="name">
              Jessica
            </div>
            <div className="rate">
              <img src={Icons.star} className="img-fluid mx-auto d-block" alt="" />
            </div>
          </div>

        </Slider>
      </div>
    </div>
  </section>)
};

export default Reviews;
